import Constants from '@intercom/embercom-composer/lib/constants';
import $ from 'jquery';
import Em from 'ember';
function insertChild(element, node, insertBefore) {
  return insertBefore && element.childNodes.length ? element.insertBefore(node, element.childNodes[0]) : element.appendChild(node);
}
export default Em.Object.extend({
  nonEditableTypes: ['IC-MENTION', 'IC-ATTRIBUTE', 'IC-MARKER'],
  textSelectors: 'p, li, h1, h2, pre',
  blockSelectors: 'ic-block, ul, ol',
  inlineTextSelectors: 'a, b, i',
  selection: Em.computed(function () {
    return window.getSelection();
  }),
  clear() {
    this.get('selection').removeAllRanges();
  },
  selectionIsInEditor($editor) {
    if (!$editor) {
      return false;
    }
    let selection = this.get('selection');
    let $closestEditor = $(selection.anchorNode).closest('.embercom-composer-editor');
    return $closestEditor.length === 1 && $closestEditor[0] === $editor[0];
  },
  getCoords($editor) {
    let selection = this.get('selection');
    if (this.selectionIsInEditor($editor)) {
      let range = selection.getRangeAt(0);
      let startRange = range.cloneRange();
      startRange.collapse(true);
      let clientRectList = startRange.getClientRects();
      let clientRect = clientRectList[clientRectList.length - 1];
      if (clientRect) {
        return {
          x: clientRect.left,
          y: clientRect.top
        };
      }
    }
    return;
  },
  getCoordsOfClosest($editor, character) {
    let selection = this.get('selection');
    if (!selection.anchorNode) {
      return;
    }
    let oldRange = selection.getRangeAt(0);
    if (oldRange.collapsed) {
      let currentNode = oldRange.startContainer;
      let currentOffset = oldRange.startOffset;
      let characterIndex = currentNode.textContent.slice(0, currentOffset).lastIndexOf(character);
      if (characterIndex === -1) {
        return false;
      }
      let newRange = document.createRange();
      newRange.setStart(currentNode, characterIndex + 1);
      this._addRangeToDomSelection(newRange);
      let coords = this.getCoords($editor);
      this._addRangeToDomSelection(oldRange);
      return coords;
    }
    return false;
  },
  selectNode(node) {
    let range = document.createRange();
    range.selectNode(node);
    this._addRangeToDomSelection(range);
  },
  isZeroWidthSpaceSelection() {
    let selection = this.get('selection');
    return selection.toString() === Constants.ZERO_WIDTH_SPACE;
  },
  collapseToStart() {
    let selection = this.get('selection');
    selection.collapseToStart();
  },
  getDimensions($editor) {
    let range;
    let startRange, endRange;
    let startRectList, endRectList;
    let startRect, endRect;
    let selection = window.getSelection();
    let width = 0,
      height = 0;
    if (this.selectionIsInEditor($editor)) {
      range = selection.getRangeAt(0);
      startRange = range.cloneRange();
      endRange = range.cloneRange();
      startRange.collapse(true);
      endRange.collapse(false);
      startRectList = startRange.getClientRects();
      endRectList = endRange.getClientRects();
      startRect = startRectList[startRectList.length - 1];
      endRect = endRectList[0];
      if (startRect && endRect && startRect.top === endRect.top) {
        width = endRect.right - startRect.left;
        height = endRect.bottom - startRect.top;
      } else {
        let clientRect = range.getClientRects()[0];
        if (clientRect) {
          let boundingRect = range.getBoundingClientRect();
          width = boundingRect.width || clientRect.width;
          height = boundingRect.height || clientRect.height;
        }
      }
    }
    return {
      height,
      width
    };
  },
  selectAll($editor) {
    let startCaret;
    let endCaret;
    let editor = $editor[0];
    let blocks = editor.childNodes;
    if (blocks.length) {
      startCaret = this._getFirstOrLastTextNode($editor, true);
      endCaret = this._getFirstOrLastTextNode($editor, true, true);
      if (endCaret.node.tagName === 'BR') {
        // You can't set selection to a BR so use the previous sibling
        endCaret.node = endCaret.node.previousSibling;
        endCaret.offset = endCaret.node.textContent.length;
      }
      this.setDomSelection(startCaret.node, startCaret.offset, startCaret.block, endCaret.node, endCaret.offset, endCaret.block);
    }
  },
  updateCaret(selectionState, $editor) {
    let endCaret;
    let blocks = this.getElementNodes($editor);
    let startBlockIndex = selectionState.get('startBlockIndex');
    let startBlock = blocks[startBlockIndex];
    if (this._isNodeAListElement(startBlock)) {
      startBlock = startBlock.childNodes[selectionState.get('startItemIndex')];
    }
    let startOffset = selectionState.get('startPositionIndex');
    let startCaret = this.fromBomToDom(startBlock, startOffset);
    let endBlockIndex = selectionState.get('endBlockIndex');
    let endBlock = blocks[endBlockIndex];
    if (this._isNodeAListElement(endBlock)) {
      endBlock = endBlock.childNodes[selectionState.get('endItemIndex')];
    }
    let endOffset = selectionState.get('endPositionIndex');
    if (!this.isSelectionRange(selectionState)) {
      endCaret = startCaret;
    } else {
      endCaret = this.fromBomToDom(endBlock, endOffset);
    }
    this.setDomSelection(startCaret.node, startCaret.offset, startBlockIndex, endCaret.node, endCaret.offset, endBlockIndex);
  },
  isComposerAnchorNode() {
    let selection = this.get('selection');
    if (selection.anchorNode) {
      let $anchorNode = $(selection.anchorNode);
      return $anchorNode.hasClass('embercom-composer-editor');
    }
    return false;
  },
  isSelectionRange(selectionState) {
    return selectionState.get('startPositionIndex') !== selectionState.get('endPositionIndex') || selectionState.get('startItemIndex') !== selectionState.get('endItemIndex') || selectionState.get('startBlockIndex') !== selectionState.get('endBlockIndex');
  },
  isDomRange() {
    let selection = this.get('selection');
    return selection.anchorNode !== selection.focusNode || selection.anchorOffset !== selection.focusOffset;
  },
  putCaretAtStart($block) {
    let textNodes = this._getText($block[0].childNodes, []);
    if (textNodes.length) {
      let node = textNodes[0];
      let blockIndex = this._getBlockIndex($block.parent().children(), $block);
      this.setDomSelection(node, 0, blockIndex, node, 0, blockIndex);
    }
  },
  getElementNodes($editor) {
    return [...$editor[0].childNodes].filter(a => a.nodeType === a.ELEMENT_NODE);
  },
  putCaretAtEnd($block) {
    let textNodes = this._getText($block[0].childNodes, []);
    if (textNodes.length) {
      let node = textNodes[textNodes.length - 1];
      let textLength = node.textContent.length;
      let blockIndex = this._getBlockIndex($block.parent().children(), $block);
      this.setDomSelection(node, textLength, blockIndex, node, textLength, blockIndex);
    }
  },
  //Convert ComposerState selection coordinations to DOM Coordinates
  fromBomToDom(block, offset) {
    let textNode;
    let childNodes = block.childNodes;
    let node = childNodes[0];
    if (!node) {
      node = this._createAndInsertEmptyTextNode(block);
    }
    //If only a single text node
    if (childNodes.length === 1 && childNodes[0].nodeType === childNodes[0].TEXT_NODE) {
      if (node.textContent === Constants.ZERO_WIDTH_SPACE && offset === 0) {
        offset = 1;
      }
      return {
        node,
        offset
      };
    }
    //Grab all the textNodes
    let charCount = 0;
    let textNodes = this._getText(childNodes, []);

    //If there are no text nodes in the block, append an empty text node to the first child element
    if (!textNodes.length) {
      let firstChildNode = childNodes[0];
      node = this._createAndInsertEmptyTextNode(firstChildNode);
      return {
        node,
        offset: 0
      };
    }

    //Calculate the corresponding node and offset according to Composer State selection
    for (let i = 0, length = textNodes.length; i < length; i++) {
      let currentTextNode = textNodes[i];
      let originalCharCount = charCount;
      if (currentTextNode.textContent === Constants.ZERO_WIDTH_SPACE) {
        if (this._isInlineTextNode(currentTextNode.parentNode)) {
          charCount++;
        }
      } else if (currentTextNode.tagName === 'BR') {
        charCount++;
      } else {
        charCount += currentTextNode.textContent.length;
      }
      //If we are in the text node we are searching for
      if (charCount >= offset) {
        //If the current element is a <br> tag we need to work out where to place the caret, i.e. after the <br> tag
        if (currentTextNode.tagName === 'BR') {
          let nodesWithBreaks = this._getText(childNodes, [], true);
          let breakTag = nodesWithBreaks[i];
          return this._getOffsetAndNode(breakTag.nextSibling);
        }
        //If the element is an attribute we don't want to place the cursor inside but rather into the next sibling text node
        if (this._isAncestorNotEditableNode(currentTextNode)) {
          textNode = this._getSiblingOfAncestorAttribute(currentTextNode);
          if (this._needsZeroWidthSpace(textNode)) {
            textNode = this._insertZeroWidthSpace(textNode);
          }
          return this._getOffsetAndNode(textNode);
        }
        return {
          node: currentTextNode,
          offset: charCount - originalCharCount - (charCount - offset)
        };
      }
    }
  },
  getSelectionOfBlock($block, getEndOfBlock) {
    if ($block.parents().length === 0) {
      // This block is not in the DOM anymore, find the real deal
      $block = $(`[data-id="${$block.data('id')}"]`);
    }
    let itemIndex = 0;
    let positionIndex = getEndOfBlock ? this._getOffsetAtEnd($block) : 0;
    let blockIndex = this._getBlockIndex($block.parent().children(), $block);
    if ($block.is('ol, ul')) {
      itemIndex = getEndOfBlock ? $block.children().length - 1 : 0;
      positionIndex = getEndOfBlock ? this._getOffsetAtEnd($block.children().last()) : 0;
    }
    return Object.create({
      startBlockIndex: blockIndex,
      startItemIndex: itemIndex,
      startPositionIndex: positionIndex,
      endBlockIndex: blockIndex,
      endItemIndex: itemIndex,
      endPositionIndex: positionIndex
    });
  },
  _getOffsetAtEnd($block) {
    return $block.text().replace(Constants.ZERO_WIDTH_SPACE, '').length;
  },
  _isAncestorNotEditableNode(node) {
    return this.get('nonEditableTypes').includes(node.parentNode.parentNode.tagName);
  },
  _getSiblingOfAncestorAttribute(node) {
    return node.parentNode.parentNode.nextSibling;
  },
  _getOffsetAndNode(textNode) {
    //Chrome won't always insert the cursor if it's only a zero-width space and the offset is 0. We need to push it along by 1
    let offset = new RegExp(`^${Constants.ZERO_WIDTH_SPACE}`).test(textNode.textContent) ? 1 : 0;
    return {
      node: textNode,
      offset
    };
  },
  _isParentNodeABlock(node) {
    return node && /^(P|LI)$/.test(node.tagName);
  },
  orderedSelection: Em.computed('startBlockIndex', 'startItemIndex', 'startPositionIndex', 'endBlockIndex', 'endItemIndex', 'endPositionIndex', function () {
    if (this.get('selectionIsReversed')) {
      this._reverseSelection();
    }
    return {
      startBlockIndex: this.get('startBlockIndex'),
      startPositionIndex: this.get('startPositionIndex'),
      startItemIndex: this.get('startItemIndex'),
      endBlockIndex: this.get('endBlockIndex'),
      endPositionIndex: this.get('endPositionIndex'),
      endItemIndex: this.get('endItemIndex')
    };
  }),
  _insertZeroWidthSpace(textNode) {
    textNode.textContent = Constants.ZERO_WIDTH_SPACE;
    return textNode;
  },
  selectionIsReversed: Em.computed('startBlockIndex', 'endBlockIndex', 'startItemIndex', 'endItemIndex', 'startPositionIndex', 'endPositionIndex', function () {
    return this.get('startBlockIndex') > this.get('endBlockIndex') || this.get('startBlockIndex') === this.get('endBlockIndex') && this.get('startItemIndex') > this.get('endItemIndex') || this.get('startBlockIndex') === this.get('endBlockIndex') && this.get('startItemIndex') === this.get('endItemIndex') && this.get('startPositionIndex') > this.get('endPositionIndex');
  }),
  _reverseSelection() {
    let startBlockIndex = this.get('startBlockIndex');
    let startPositionIndex = this.get('startPositionIndex');
    let startItemIndex = this.get('startItemIndex');
    this.set('startBlockIndex', this.get('endBlockIndex'));
    this.set('startPositionIndex', this.get('endPositionIndex'));
    this.set('startItemIndex', this.get('endItemIndex'));
    this.set('endBlockIndex', startBlockIndex);
    this.set('endPositionIndex', startPositionIndex);
    this.set('endItemIndex', startItemIndex);
  },
  clearSelection() {
    this.get('selection').removeAllRanges();
  },
  getSelection($editor) {
    let allSelectors = `${this.get('textSelectors')}, ${this.get('blockSelectors')}`;
    let selection = this.get('selection');
    if (this.selectionIsInEditor($editor)) {
      let normalizedList;
      let normalizedAnchor;
      let normalizedFocus;
      let $nodes = $editor.children();
      let anchorNode = selection.anchorNode;
      let focusNode = selection.focusNode;
      let $anchorNode = $(anchorNode);
      let $focusNode = $(focusNode);
      let $startBlock = $anchorNode.closest(allSelectors);
      let $endBlock = $focusNode.closest(allSelectors);
      let anchorOffset = selection.anchorOffset;
      let focusOffset = selection.focusOffset;
      if (this._isNodeAListElement(anchorNode)) {
        normalizedList = this._normalizeListItems(anchorNode, anchorOffset, 'anchor');
        anchorNode = normalizedList.node;
        anchorOffset = normalizedList.offset;
        $startBlock = $(anchorNode);
      }
      normalizedAnchor = this._normalizeNodeAndOffset(anchorNode, anchorOffset, $startBlock, 'anchor');
      anchorNode = normalizedAnchor.node;
      anchorOffset = normalizedAnchor.offset;
      $startBlock = normalizedAnchor.$block;
      if (this._isNodeAListElement(focusNode)) {
        normalizedList = this._normalizeListItems(focusNode, focusOffset, 'focus');
        focusNode = normalizedList.node;
        focusOffset = normalizedList.offset;
        $endBlock = $(focusNode);
      }
      normalizedFocus = this._normalizeNodeAndOffset(focusNode, focusOffset, $endBlock, 'focus');
      focusNode = normalizedFocus.node;
      focusOffset = normalizedFocus.offset;
      $endBlock = normalizedFocus.$block;
      let startNodes = this._getText($startBlock[0].childNodes, []);
      let endNodes = this._getText($endBlock[0].childNodes, []);
      let startOffset = this.fromDomToBom(startNodes, anchorNode, anchorOffset);
      this.set('startBlockIndex', this._getBlockIndex($nodes, $startBlock));
      this.set('startPositionIndex', startOffset);
      this.set('startItemIndex', this._getItemIndex($startBlock));
      let endOffset = this.fromDomToBom(endNodes, focusNode, focusOffset);
      this.set('endBlockIndex', this._getBlockIndex($nodes, $endBlock));
      this.set('endPositionIndex', endOffset);
      this.set('endItemIndex', this._getItemIndex($endBlock));
      return this.get('orderedSelection');
    }
  },
  _normalizeListItems(node, offset, mode) {
    let $block;
    let childNodes = node.childNodes;
    let newNode = childNodes[offset];
    if (mode === 'focus') {
      newNode = childNodes[offset - 1];
    }
    $block = $(newNode);
    offset = mode === 'anchor' ? 0 : $block.text().length;
    return {
      node: newNode,
      $block,
      offset
    };
  },
  _normalizeNodeAndOffset(node, offset, $block, mode) {
    //To make mapping our DOM Selection to ComposerState translation easier we always try to map our nodes and offsets to DOM TextNodes and their corresponding offsets
    let $node = $(node);
    let childNodes = node.childNodes;
    //If the $node is a "block-level" text element
    if ($node.is(this.get('textSelectors')) && childNodes.length && childNodes[offset]) {
      if (childNodes[offset].tagName === 'BR' || offset < childNodes.length) {
        node = childNodes[offset];
        offset = 0;
      }
      if (offset >= childNodes.length) {
        offset = childNodes.length - 1;
      }
    } else if (childNodes[offset] && childNodes[offset].tagName === 'BR') {
      node = childNodes[offset];
      offset = 0;
    }

    //If the selection anchor or focus nodes are the root editor node find the first and last text node respectively
    if ($node.is('.embercom-composer-editor')) {
      let textNode;
      if (mode === 'anchor') {
        $block = $node.children().first();
        textNode = this._getFirstOrLastTextNode($node, true);
      } else {
        $block = $node.children().last();
        textNode = this._getFirstOrLastTextNode($node, true, true);
      }
      offset = textNode.offset;
      node = textNode.node;
    }
    return {
      node,
      offset,
      $block
    };
  },
  setDomSelection(startNode, startOffset, startBlockIndex, endNode, endOffset, endBlockIndex) {
    let range = document.createRange();
    range.setStart(startNode, startOffset);
    if (endNode) {
      range.setEnd(endNode, endOffset);
    }
    if (startOffset === endOffset && startBlockIndex === endBlockIndex) {
      range.collapse(false);
    }
    this._addRangeToDomSelection(range);
  },
  _addRangeToDomSelection(range) {
    this.get('selection').removeAllRanges();
    this.get('selection').addRange(range);
  },
  _getText(childNodes, textNodes) {
    textNodes = textNodes || [];
    //Recursively get all the text nodes
    for (let i = 0, length = childNodes.length; i < length; i++) {
      let currentNode = childNodes[i];
      if (currentNode.nodeType === currentNode.TEXT_NODE) {
        textNodes.push(currentNode);
      } else if (currentNode.tagName === 'BR') {
        textNodes.push(currentNode);
      } else if (this.get('nonEditableTypes').includes(currentNode.tagName) || $(currentNode).attr('contenteditable') !== 'false') {
        textNodes.concat(this._getText(currentNode.childNodes, textNodes));
      }
    }
    return textNodes;
  },
  _getContainingBlockIndex(node, $editor) {
    let element = node.parentNode;
    let $parentBlock = $(element).closest('p, h1, h2, ol, ul, ic-block');
    return this._getBlockIndex($editor.children(), $parentBlock);
  },
  _getBlockIndex($nodes, $block) {
    if ($block.is('li')) {
      $block = $block.parent();
    }
    return $nodes.index($block);
  },
  _getItemIndex($block) {
    if (!$block.is('li')) {
      return 0;
    }
    return $block.parent().children().index($block);
  },
  _getFirstOrLastTextNode($editor, addEmptyTextNodeIfNone, isLast) {
    let offset;
    let textNode;
    let textNodes;
    let textContent;
    let textNodePosition;
    let blocks = this.getElementNodes($editor);
    let blockPosition = isLast ? blocks.length - 1 : 0;
    let block = blocks[blockPosition];
    let blockChildNodes = block.childNodes;
    if (!blockChildNodes) {
      return {
        node: null,
        block: -1,
        offset: -1
      };
    }
    if (!blockChildNodes && addEmptyTextNodeIfNone) {
      blockChildNodes = block.childNodes[0];
    }
    textNodes = this._getText(blockChildNodes, []);
    textNodePosition = isLast ? textNodes.length - 1 : 0;
    if (!(!textNodes.length && addEmptyTextNodeIfNone)) {
      textNode = textNodes[textNodePosition];
    }
    textContent = textNode.textContent;
    offset = isLast ? textContent.length : 0;
    return {
      node: textNode,
      block: this._getContainingBlockIndex(textNode, $editor),
      offset
    };
  },
  fromDomToBom(textNodes, selectedNode, domOffset) {
    let charCount = 0;
    let countZeroWidthSpaces = 0;
    //Empty Paragraph
    if (selectedNode.nodeType === selectedNode.ELEMENT_NODE && /^P|LI$/.test(selectedNode.tagName) && !selectedNode.innerHTML.length && selectedNode.childNodes) {
      selectedNode = textNodes[0];
    }
    //If we've applied the hack to insert a caret in Chrome (https://bugs.webkit.org/show_bug.cgi?id=15256), we need to tweak the offset so it doesn't screw up our selection values
    if (textNodes.length === 0 && (!selectedNode || selectedNode.textContent === Constants.ZERO_WIDTH_SPACE)) {
      return 0;
    }
    for (let i = 0, length = textNodes.length; i < length; i++) {
      let currentTextNode = textNodes[i];
      let text = currentTextNode.textContent;
      if (currentTextNode === selectedNode) {
        if (currentTextNode.tagName === 'BR') {
          return charCount;
        }
        countZeroWidthSpaces = this._getZeroWidthSpacesCount(text.substring(0, domOffset));
        return text === Constants.ZERO_WIDTH_SPACE ? charCount : charCount + domOffset - countZeroWidthSpaces;
      }
      if (currentTextNode.tagName === 'BR') {
        charCount++;
      } else {
        countZeroWidthSpaces = this._getZeroWidthSpacesCount(text);
        charCount = text === Constants.ZERO_WIDTH_SPACE ? charCount : charCount + text.length - countZeroWidthSpaces;
      }
    }
    return charCount;
  },
  getStartOfCurrentLine() {
    let selection = this.get('selection');
    let anchorNode = selection.anchorNode;
    let anchorOffset = selection.anchorOffset;
    let $block = $(this.getSelectionElement()).closest('p, li, pre, h1, h2');
    if ($block.length === 0) {
      return;
    }
    let $blocks = $block.closest('.embercom-composer-editor').children();
    let blockTextNodes = this._getText($block[0].childNodes, [], true);
    let textNodesToSearch = this._getNodesUntilReferenceNode(blockTextNodes, anchorNode);
    if (!textNodesToSearch) {
      return false;
    }
    let startOfCurrentLine = this._findStartOfCurrentLine(textNodesToSearch, anchorOffset);
    return {
      blockIndex: this._getBlockIndex($blocks, $block),
      positionIndex: this.fromDomToBom(blockTextNodes, startOfCurrentLine.node, startOfCurrentLine.offset),
      itemIndex: this._getItemIndex($block)
    };
  },
  _getNodesUntilReferenceNode(nodes, referenceNode) {
    for (let i = 0, length = nodes.length; i < length; i++) {
      let currentTextNode = nodes[i];
      if (referenceNode === currentTextNode) {
        //Only take nodes in the block up until the currentTextNode
        return this._convertNodeListToArray(nodes).slice(0, i + 1);
      }
    }
  },
  _convertNodeListToArray(nodeList) {
    return [].slice.call(nodeList);
  },
  getSelectionElement() {
    let anchorNode = this.get('selection').anchorNode;
    return anchorNode.nodeType === anchorNode.ELEMENT_NODE ? anchorNode : anchorNode.parentNode;
  },
  _findStartOfCurrentLine(nodes, currentOffset) {
    let currentNode;
    let startingTextOffset;
    let startOfCurrentLine;
    let startingCaretTop = this._getCaretTop();
    for (let nodeCount = nodes.length - 1, i = nodeCount; i > -1; i--) {
      currentNode = nodes[i];

      //Finding a <br> means it's the end of the previous line
      if (this._isNodeATag(currentNode, 'BR')) {
        return {
          node: nodes[i + 1],
          offset: 0
        };
      }

      //If we're on the first iteration we only need to check from the current anchorOffset
      startingTextOffset = i === nodeCount ? currentOffset : currentNode.textContent.length;
      startOfCurrentLine = this._iterateOverTextToFindStartOfLine(currentNode, startingTextOffset, startingCaretTop);
      if (startOfCurrentLine) {
        return startOfCurrentLine;
      }
    }
    return {
      node: nodes[0],
      offset: 0
    };
  },
  _iterateOverTextToFindStartOfLine(currentNode, startingTextOffset, caretTop) {
    let recalculatedCaretTop;
    for (let offset = startingTextOffset - 1; offset > -1; offset--) {
      this.setDomSelection(currentNode, offset);
      recalculatedCaretTop = this._getCaretTop();
      if (recalculatedCaretTop !== caretTop && currentNode.parentNode.parentNode.tagName !== 'IC-ATTRIBUTE') {
        return {
          node: currentNode,
          offset
        };
      }
    }
  },
  _isNodeATag(node, tag) {
    return node.nodeType === node.ELEMENT_NODE && node.tagName === tag;
  },
  _getCaretTop() {
    let clientRects = this.get('selection').getRangeAt(0).getClientRects();
    if (clientRects.length > 0) {
      // flooring because chrome gives inconsistent values here depending on where the selection was set from
      return Math.floor(this.get('selection').getRangeAt(0).getClientRects()[0].top);
    }
  },
  _getZeroWidthSpacesCount(text) {
    let zeroWidthTest = text.match(Constants.ZERO_WIDTH_SPACE_GLOBAL_REGEX);
    return zeroWidthTest ? zeroWidthTest.length : 0;
  },
  _createAndInsertEmptyTextNode(element, insertBefore) {
    let emptyTextNode = this._createEmptyTextNode();
    return insertChild(element, emptyTextNode, insertBefore);
  },
  //We need to insert an invisible space character to circumvent this Chrome bug https://bugs.webkit.org/show_bug.cgi?id=15256
  _createEmptyTextNode() {
    return document.createTextNode(Constants.ZERO_WIDTH_SPACE);
  },
  _containsZeroWidthSpace(node) {
    return new RegExp(Constants.ZERO_WIDTH_SPACE).test(node.textContent);
  },
  _needsZeroWidthSpace(node) {
    return node.textContent.length === 0;
  },
  _removeNode(node) {
    node.parentNode.removeChild(node);
  },
  _isInlineTextNode(node) {
    return $(node).is(this.get('inlineTextSelectors')) && node.childNodes.length === 1;
  },
  _findAncestorNode(node, tagName) {
    let parentNode = node.parentNode;
    if (!parentNode || this._isParentNodeABlock(parentNode)) {
      return null;
    }
    return parentNode.tagName === tagName ? parentNode : this._findAncestorNode(parentNode, tagName);
  },
  _isNodeAListElement(node) {
    return /^(O|U)L$/.test(node.tagName);
  },
  isAtStartOfNode() {
    let selection = this.get('selection');
    return selection.anchorNode && selection.anchorOffset <= 1;
  },
  isAtEndOfNode() {
    let selection = this.get('selection');
    return selection.anchorNode && selection.anchorOffset >= selection.anchorNode.textContent.length - 1;
  },
  isImmediatelyBeforeBr() {
    return this.get('selection').anchorNode && this.get('selection').anchorOffset === 0 && this.get('selection').anchorNode.previousSibling && this.get('selection').anchorNode.previousSibling.tagName === 'BR';
  },
  splitEntity(type) {
    if (this.isDomRange()) {
      throw new Error('Cannot split an entity when a range is selected');
    }
    let anchorNode = this.get('selection').anchorNode;
    let offset = this.get('selection').anchorOffset;
    let newAnchorNode = this._splitEntityAtAnchorOffset(type, anchorNode, offset);
    let range = document.createRange();
    range.setStart(newAnchorNode, 1);
    range.setEnd(newAnchorNode, 1);
    range.collapse(true);
    this._addRangeToDomSelection(range);
  },
  _splitEntityAtAnchorOffset(type, anchorNode, offset) {
    let rightTree, middleTree, rightCopy, middleCopy, lastSiblingIndex;
    let newAnchorNode = document.createTextNode(Constants.ZERO_WIDTH_SPACE);
    let currentNode = anchorNode;
    //eslint-disable-next-line no-constant-condition
    while (true) {
      rightCopy = currentNode.cloneNode();
      middleCopy = currentNode.cloneNode();
      if (currentNode.nodeType === Node.TEXT_NODE) {
        currentNode.textContent = currentNode.textContent.slice(0, offset);
        rightCopy.textContent = rightCopy.textContent.slice(offset);
      } else {
        rightCopy.removeAttribute('data-id');
        middleCopy.removeAttribute('data-id');
        if (currentNode.childNodes.length > 1) {
          let siblingToMove;
          while (siblingToMove = currentNode.childNodes[lastSiblingIndex + 1]) {
            rightCopy.insertBefore(siblingToMove, null);
          }
        }
      }
      if (!rightTree) {
        if (rightCopy.textContent !== '') {
          rightTree = rightCopy;
        }
      } else {
        rightCopy.insertBefore(rightTree, rightCopy.childNodes[0]);
        rightTree = rightCopy;
      }
      if (currentNode.tagName === type) {
        break;
      }
      if (!middleTree) {
        middleTree = newAnchorNode;
      } else {
        middleCopy.insertBefore(middleTree, null);
        middleTree = middleCopy;
      }
      lastSiblingIndex = Array.prototype.indexOf.call(currentNode.parentNode.childNodes, currentNode);
      currentNode = currentNode.parentNode;
    }
    let parent = currentNode.parentNode;
    parent.insertBefore(middleTree, currentNode.nextSibling);
    if (rightTree && rightTree.textContent) {
      parent.insertBefore(rightTree, middleTree.nextSibling);
    }
    if (currentNode.textContent === '') {
      parent.removeChild(currentNode);
    }
    return newAnchorNode;
  },
  forceIntoNextEntityOfType(type) {
    let anchorNode = this.get('selection').anchorNode;
    let caretNode;
    if (anchorNode.nextSibling && anchorNode.nextSibling.tagName === type) {
      caretNode = anchorNode.nextSibling;
    } else if (anchorNode.parentNode.nextSibling && anchorNode.parentNode.nextSibling.tagName === type) {
      caretNode = anchorNode.parentNode.nextSibling;
    } else if (anchorNode.nextSibling && anchorNode.nextSibling.childNodes.length > 0 && anchorNode.nextSibling.childNodes[0].tagName === type) {
      caretNode = anchorNode.nextSibling.childNodes[0];
    }
    let caretOffset = 1;
    if (this._nodeHasChildWithContent(caretNode)) {
      caretNode = caretNode.childNodes[0];
      caretOffset = 0;
    }
    if (caretNode) {
      let range = document.createRange();
      range.setStart(caretNode, caretOffset);
      range.setEnd(caretNode, caretOffset);
      range.collapse(false);
      this._addRangeToDomSelection(range);
    }
  },
  _nodeHasChildWithContent(node) {
    return node && node.childNodes && node.childNodes[0] && node.childNodes[0].textContent !== Constants.ZERO_WIDTH_SPACE;
  }
});